import BaseService from '@/services/BaseService'

class ManufacturingCommandService {

	constructor() {
		this._httpService = new BaseService();
	}

	getManufacturingCommands() {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/manufacturing-management/manufacturing-commands`,
			method: 'GET'
		}
		console.info('get production-commands')
		return this._httpService.service(settings)
	}

	getManufacturingCommand(id) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/manufacturing-management/manufacturing-commands/${id}`,
			method: 'GET'
		}
		console.info('get production-commands')
		return this._httpService.service(settings)
	}

	getManufacturingCommandInProduction(id) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/manufacturing-management/manufacturing-commands/${id}/production`,
			method: 'GET'
		}
		console.info('get production-commands')
		return this._httpService.service(settings)
	}

	postManufacturingCommand(manufacturingCommand) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/manufacturing-management/manufacturing-commands`,
			data: manufacturingCommand,
			method: 'POST'
		}
		console.info('get production-commands')
		return this._httpService.service(settings)
	}

	putManufacturingCommand(id, manufacturingCommand) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/manufacturing-management/manufacturing-commands/${id}`,
			data: manufacturingCommand,
			method: 'PUT'
		}
		console.info('get production-commands')
		return this._httpService.service(settings)
	}

	putManufacturingCommandConfirmation(id) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/manufacturing-management/manufacturing-commands/${id}/confirm`,
			method: 'PUT'
		}
		console.info('get production-commands')
		return this._httpService.service(settings)
	}

	putManufacturingCommandCancelation(id) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/manufacturing-management/manufacturing-commands/${id}/cancel`,
			method: 'PUT'
		}
		console.info('get production-commands')
		return this._httpService.service(settings)
	}

	putManufacturingCommandAddDetailItems(id, data) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/manufacturing-management/manufacturing-commands/${id}/add-items`,
			data: data,
			method: 'PUT'
		}
		console.info('get production-commands')
		return this._httpService.service(settings)
	}

	deleteManufacturingCommandDetail(commandId, orderDetailId) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/manufacturing-management/manufacturing-commands/${commandId}/details/${orderDetailId}`,
			data: null,
			method: 'DELETE'
		}
		console.info('get production-commands')
		return this._httpService.service(settings)
	}

	deleteManufacturingCommand(commandId) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/manufacturing-management/manufacturing-commands/${commandId}`,
			data: null,
			method: 'DELETE'
		}
		console.info('get deleteManufacturingCommand')
		return this._httpService.service(settings)
	}

}

export default ManufacturingCommandService